import React from 'react'
import { Stack, Typography } from '@mui/material'
import { useWaterNeuron } from '@plug-core/hooks/useStaking'
import { useTranslation } from 'react-i18next'
import { WaterNeuronStaking } from './components/Stake'

export const WaterNeuronContainer = () => {
  const { t } = useTranslation()

  const { hasWnError, wnInfo, waterNeuron, icpToken, nicpToken } = useWaterNeuron()

  let content = null
  if (!icpToken || !nicpToken || hasWnError) {
    content = (
      <Typography variant="h6" fontSize={16} textAlign="center" mt={10}>
        {t('stake.failedToLoadData')}
      </Typography>
    )
  } else if (waterNeuron.current) {
    content = (
      <WaterNeuronStaking
        icpToken={icpToken}
        nicpToken={nicpToken}
        wnInfo={wnInfo}
        waterNeuron={waterNeuron.current}
      />
    )
  }

  return <Stack>{content}</Stack>
}
